export const branchPermission = {
    branchView: "branch.view",
    branchCreate: "branch.create",
    branchDelete: "branch.delete",
    branchUpdate: "branch.update",
    branchExport: "branch.export",
};
